<template>
  <div class="container">
    <el-form>
      <el-form-item>
        <excelExport
          ref="export"
          :tableName="tableName"
          :values="values"
          :titles="titles"
          @startExport="startExport"
        >
          <el-radio v-model="extype" :label="1"
            >当前页数据，{{ DataList.length }}条</el-radio
          >
          <el-radio v-model="extype" :label="2"
            >导出当前条件的全部数据</el-radio
          >
        </excelExport>
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="openRemark(row)"
            >补充说明</el-button
          >
        </div>
      </template>
    </auto-table>

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入内容"
        v-model="remark"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setRemark">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import excelExport from "@/components/excel/excelExport.vue";
export default {
  components: {
    excelExport,
  },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "联系人", value: "name" },
        { name: "联系电话", value: "phone" },
        { name: "类目", value: "categories" },
        { name: "门店名称", value: "mechanism_name" },
        { name: "联系说明", value: "remark" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 2,
      id: "",
      remark: "",
      dialogVisible: false,
      cur: {},
      extype: 1,
      tableName: "沙龙报名",
      values: [
        "name",
        "phone",
        "categories",
        "mechanism_name",
        "remark",
        "create_time",
      ],
      titles: ["联系人", "电话", "类目", "门店名称", "联系说明", "报名时间"],
    };
  },

  mounted() {
    this.id = this.$route.query.id;
    this.getList(1);
  },

  methods: {
    // 导出表格
    startExport() {
      if (this.extype === 1) {
        let DataList = this.DataList;
        this.$refs.export.importExcel(DataList);
      } else {
        this.exportInfo();
      }
    },
    exportInfo() {
      let params = {
          salon_id: this.id,
      };
     
      this.$axios({
        url: "/user/salonJoinRecord/query",
        params,
      }).then((res) => {
        let DataList = res.data.data;
        this.$refs.export.importExcel(DataList);
      });
    },
    openRemark(row) {
      this.cur = row;
      this.dialogVisible = true;
      this.remark = "";
    },
    setRemark(row) {
      if (!this.remark) {
        return;
      }

      this.$post("/user/salonJoinRecord/update", {
        remark: this.remark,
        id: this.cur.id,
      }).then((res) => {
        this.dialogVisible = false;
        this.getList(1);
      });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/salonJoinRecord/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          salon_id: this.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
</style>